import PendoCheckbox from '../../components/checkbox/pendo-checkbox.vue.js';
import PendoButton from '../../components/button/pendo-button.vue.js';
import PendoLegalAcknowledgement from '../legal-acknowledgement/pendo-legal-acknowledgement.vue.js';
import PendoModal from '../../components/modal/pendo-modal.vue.js';

var script = {
  name: 'PendoDataCollectionConsentToggle',
  components: {
    PendoButton,
    PendoCheckbox,
    PendoLegalAcknowledgement,
    PendoModal
  },
  props: {
    isForCustomer: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      required: true
    },
    legalTitle: {
      type: String,
      default: 'Increased Data Collection'
    },
    requiresOptOut: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'checkbox',
      validator: type => ['checkbox', 'button'].includes(type)
    }
  },
  data() {
    return {
      showConfirmOptOut: false,
      showLegalAcknowledgement: false
    };
  },
  methods: {
    toggleConsent(value) {
      if (value === true) {
        this.showLegalAcknowledgement = true;
        return;
      }
      if (value === false && this.requiresOptOut) {
        this.showConfirmOptOut = true;
      }
      if (value === false && !this.requiresOptOut) {
        this.changeValue(false);
      }
    },
    changeValue(value) {
      this.$emit('change', value);
      this.showConfirmOptOut = false;
      this.showLegalAcknowledgement = false;
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-data-collection-consent-toggle.vue2.js.map
